import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseAISummaryWidget from './common/BaseAISummaryWidget'
import ChatAISummary from '../CopilotSettings/icons/Insights/ChatAISummary'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { trackEvent } from 'utils/analyticsUtils'
import useSelectPatientView from '../../useSelectPatientView'
import { PatientSidebarItemKeys } from '../../PatientSidebar/patientSidebarConsts'

const ChatSummaryWidget = ({ isLoading, chatSummary = '', updatedAt }) => {
  const { t } = useTranslation()

  const { selectPatientView } = useSelectPatientView()

  const handleButtonClick = () => {
    trackEvent('Patient Copilot - Chat AI Summary - Go to chat clicked')
    selectPatientView(PatientSidebarItemKeys.Chat)
  }

  return (
    <BaseAISummaryWidget
      title={t('pages.patients.patientSidebar.items.copilot.copilotInsights.chatSummary.title')}
      titleIcon={<ChatAISummary />}
      isLoading={isLoading}
      buttonLabel={t('pages.patients.patientSidebar.items.copilot.copilotInsights.chatSummary.button')}
      onButtonClick={handleButtonClick}
      updatedAt={updatedAt}
    >
      {chatSummary ? (
        <DazzedParagraph14>{chatSummary}</DazzedParagraph14>
      ) : (
        <DazzedParagraph14 color="var(--text-color-18)" strong>
          {t('pages.patients.patientSidebar.items.copilot.copilotInsights.noDataAvailable')}
        </DazzedParagraph14>
      )}
    </BaseAISummaryWidget>
  )
}

export default ChatSummaryWidget
